module.exports = __webpack_public_path__ + "static/media/oleophobic-video.bdec5bb2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/oakleyStealth/oleophobic-video.mp4
// module id = 3504
// module chunks = 0